/**
 * @file Simple Tracking Pixel code. Add the URL you want to call, and the
 * url is called, invisibly.
 *
 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TrackingPixel(props) {
  // Load the image source URL without actually creating a image DOM element
  // (which, since it's invisible, isn't necessary anyway).
  var image = new Image();
  image.src = props.url;

  return null;
}

TrackingPixel.propTypes = {
  /**
   * Source URL of the tracking pixel image to load.
   */
  url: _react2.default.PropTypes.string.isRequired
};

exports.default = TrackingPixel;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-trackingpixel/dist/index.js
// module id = 30
// module chunks = 0